import '../css/main.css';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Outlet } from 'react-router-dom';
import AgentStatus from './agenttoolbar/agentstatus'
import { useNavigate } from "react-router-dom";
import AgentGroups from './agenttoolbar/agentgroups';
import Phone from './phone/phone';
import { withTranslation } from "react-i18next";
import { deselectInteraction } from '../redux/interactionsSlice';
import SignalRService from "../controllers/SignalRService";
import { Row, Col, Button, Form } from 'react-bootstrap';
import ContactFormCall from './misc/contactformcall';
import AddressBookFormCall from './misc/AddressBookFormCall';
import FidelityContactsSelection from './contacts/fidelitycontactsselection';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import ChatEventDispacherService from '../controllers/ChatEventDispacherService';
import Timeline from './misc/timeline';
import { clearContacts, setContacts } from '../redux/agentSlice'
import { setAiEnabled } from 'src/redux/parametersSlice';
import ChatsService from 'src/controllers/ChatController';
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Toastr from './utils/toastr';
import Draggable from 'react-draggable';
import AiAssistant from './chat/aiassistant/aiassistant';
import { setMonitorToken, setMonitorConnected, setMonitorConnectionLost } from 'src/redux/agentSlice';
import MonitorService from 'src/controllers/MonitorService';
import MonitorSessionClosedNotification from './misc/monitorSessionClosedNotification';
import RequestDevice from './misc/RequestDevice';
import ErrorBoundary from './errorboundary';

class Main extends Component {

    constructor(props) {
        super(props);

        let y = -70;

        if (window.innerWidth > 1360 && window.innerWidth <= 1900)
            y = -100;
        if (window.innerWidth <= 1360)
            y = -120;

        this.state = {
            showForm: false,
            form: "",
            formDate: "",
            view: "form",
            noFormView: "contact",
            showBook: false,
            interaction: null,
            newContact: false,
            search: "",
            searchContacts: false,
            position: { x: window.innerWidth - 100, y: y },
            phoneCursor: "pointer",
            inboundUrl: "",
            showSessionClosedModal: false,
            DynamicComponent: null,
            reqDeviceShow: false,
        }

        this.inboxClick = this.inboxClick.bind(this);
        this.reportsClick = this.reportsClick.bind(this);
        this.contactsClick = this.contactsClick.bind(this);
        this.dashboardClick = this.dashboardClick.bind(this);
        this.logoClick = this.logoClick.bind(this);
        this.setFormUrl = this.setFormUrl.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
        this.formClick = this.formClick.bind(this);
        this.contactClick = this.contactClick.bind(this);
        this.timelineClick = this.timelineClick.bind(this);
        this.toggleBook = this.toggleBook.bind(this);
        this.noFormContactClick = this.noFormContactClick.bind(this);
        this.noFormTimelineClick = this.noFormTimelineClick.bind(this);
        this.toggleNewContact = this.toggleNewContact.bind(this);
        this.setSearch = this.setSearch.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.setSearchContacts = this.setSearchContacts.bind(this);
        this.searchKeyDown = this.searchKeyDown.bind(this);
        this.handleStart = this.handleStart.bind(this);
        this.handleStop = this.handleStop.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.extraClick = this.extraClick.bind(this);
        this.toggleSessionClosed = this.toggleSessionClosed.bind(this);
        this.login = this.login.bind(this);
        this.handleConnectionLost = this.handleConnectionLost.bind(this);
        this.connect = this.connect.bind(this);
        this.toggleReqDevice = this.toggleReqDevice.bind(this);
        SignalRService.registerURLEvent(this.setFormUrl);
        this.toastrRef = React.createRef();
    }

    handleResize = () => {

        let saved = localStorage.getItem("phone-position");

        if (saved) {
            try {
                let parsed = JSON.parse(saved);

                if (parsed.x > window.innerWidth)
                    parsed.x = window.innerWidth - 100;

                if (parsed.y > -65) {
                    if (window.innerHeight > 900)
                        parsed.y = -70;

                    if (window.innerHeight <= 900)
                        parsed.y = -100;

                    if (window.innerHeight <= 800)
                        parsed.y = -120;
                    if (window.innerHeight <= 600)
                        parsed.y = -130;
                    if (window.innerHeight <= 500)
                        parsed.y = -150;
                }

                this.setState({ position: parsed });
            } catch (e) {
                console.error("Invalid ai saved position");
            }
        }
    }

    login() {

        let userStr = localStorage.getItem("fc-logged");

        if (userStr) {
            let user = JSON.parse(userStr);
            let tenantName = window.location.host.split(".")[0];
            let tenantAlias = window.location.hostname;
            if (tenantAlias === 'localhost' || tenantAlias === '127.0.0.1' || tenantAlias === "dev.andrei.io")
                tenantName = "devomni";//TRAMPA,

            let userdata = {
                "username": user.userName,
                "password": user.password,
                "tenant": tenantName,
                "tenantAlias": tenantAlias,
                "loginToken": "",
                "userLocalStorage": true
            };

            MonitorService.login(userdata, res => {
                console.log(res.data);
                if (res && res.data !== null && res.data !== "" && res.data.id !== null) {
                    this.props.setMonitorToken(res.data.token);
                    this.connect(res.data.token);

                } else {
                    setTimeout(() => {
                        this.login();
                    }, 5000);
                }
            });
        }
    }

    handleConnectionLost() {
        let token = this.props.token;
        this.props.setMonitorConnectionLost(true);
        this.props.setMonitorConnected(false);
        setTimeout(() => {
            MonitorService.checktoken(token, res => {
                if (!res.data) {
                    this.login();
                } else {
                    if (!MonitorService?.stompClient?.connected) {
                        this.connect(token);
                    }
                }
            });
        }, 5000);

    }
    connect(token) {
        MonitorService.connect(token, res => {

            if (this.state.showSessionClosedModal)
                this.setState({ showSessionClosedModal: false });



            if (MonitorService?.stompClient?.connected) {

                this.props.setMonitorConnected(true);
                this.props.setMonitorConnectionLost(false);

                MonitorService.stompClient.subscribe(`/user/${token}/topic/notify/`, (notification) => {
                    const notify = notification.body;
                    switch (notify) {
                        case 'logout':
                            this.setState({ showSessionClosedModal: true });
                            this.props.setMonitorConnected(false);
                            this.props.setMonitorConnectionLost(false);
                            break;
                        default:
                            break;
                    }
                }, { id: "notifications" });

            } else {
                this.props.setMonitorConnected(false);
                this.props.setMonitorConnectionLost(true);
            }
        });
    }

    componentDidMount() {

        ChatsService.aiEnabled(this.props.setAiEnabled);
        this.handleResize();
        let token = this.props.token;

        this.setState({
            connected: MonitorService?.stompClient?.connected
        });

        if (token != null) {
            MonitorService.checktoken(token, res => {
                if (!res.data) {
                    this.login();
                } else {
                    if (!MonitorService?.stompClient?.connected) {
                        this.connect();
                    }
                }
            });
        } else {
            this.login();
        }
        document.addEventListener('wsConnectionLost', this.handleConnectionLost);
        window.addEventListener('resize', this.handleResize);

        if (this.props.integrationScript) {
            const script = document.createElement('script');
            script.src = this.props.integrationScript;
            script.type = "module";
            script.onload = () => {
                if (window.AgentIntegration) {
                    this.setState({ DynamicComponent: window.AgentIntegration });
                }
            };
            document.body.appendChild(script);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('wsConnectionLost', this.handleConnectionLost);
    }
    componentDidUpdate(prevProps, prevState) {
        // if (this.state.view !== "contacts" && (this.props.contacts !== null || this.props.contacts.length == 0))
        //     this.contactClick();

        if (this.props.extraCallDataType === 'auto' && this.props?.extraCallData?.trim() !== ""
            && prevProps.extraCallData !== this.props.extraCallData)
            window.open(this.props?.extraCallData, '_blank');
    }

    inboxClick(e) {
        e.preventDefault();
        this.props.navigate("interactions");
        this.setState({
            showForm: false,
            showBook: false
        });
    }

    reportsClick(e) {
        e.preventDefault();
        this.props.deselectInteraction();
        this.props.navigate("reports");
        this.setState({
            showForm: false,
            showBook: false
        });
    }

    contactsClick(e) {
        e.preventDefault();
        this.props.deselectInteraction();
        this.props.navigate("contacts");
        this.setState({
            showForm: false,
            showBook: false
        });
    }

    dashboardClick(e) {
        e.preventDefault();
        this.props.deselectInteraction();
        this.props.navigate("dashboard");
        this.setState({
            showForm: false,
            showBook: false
        });
    }

    logoClick(e) {
        e.preventDefault();
    }

    setFormUrl = (data) => {

        //NECESARIO PARA EVITAR TEMAS DE CARRERAS
        setTimeout(() => {
            const updates = { inboundUrl: data.inbound || "", };

            if (this.state.formDate !== data.date) {
                updates.showForm = data.form !== "";
                updates.form = data.form;
                updates.formDate = data.date;
                updates.showBook = data.form === "";
                updates.view = data.form !== "" ? "form" : "contact";
            }

            if (data.inbound && data.inbound !== this.state.inboundUrl) {
                console.log(`INBOUND_URL: ${data.inbound}`);
                window.open(data.inbound, '_blank');
            }

            this.setState(updates);

        }, 1000);

    }

    hideFormUrl = () => {
        this.setState({
            showForm: false,
            form: "",
            formDate: new Date(),
            showBook: false,
            interaction: null
        });
        this.props.clearContacts();

    }

    toggleForm() {
        this.setState({
            showForm: !this.state.showForm
        });
    }

    formClick(e) {
        this.setState({ view: "form" });
    }

    contactClick(e) {
        this.setState({ view: "contact" });
    }

    timelineClick(e) {
        let interaction = {
            bookId: this.props.contacts[0]?.contactId,
            contacts: this.props.contacts || [],
            from: this.props.phoneStatus.party || this.props.contacts[0]?.party || this.props.contacts[0]?.mail || "",
            email: this.props.contacts[0]?.mail || "",
            phone: this.props.phoneStatus.party || this.props.contacts[0]?.party,
            name: this.props.contacts[0]?.name || ""
        };

        this.setState({ view: "timeline", interaction: interaction });
    }

    toggleBook() {
        this.setState({
            showBook: !this.state.showBook,
            view: "contact"
        });
    }

    noFormContactClick(e) {
        this.setState({ noFormView: "contact" });
    }

    noFormTimelineClick(e) {
        this.setState({ noFormView: "timeline" });
    }

    toggleNewContact = e => {
        this.props.setContacts([]);
        this.setState({ newContact: true, searchContacts: false });
    }


    handleSearchClick(elem) {
        if (this.state.search !== null && this.state.search.length >= 3) {
            this.setState({ newContact: false, searchContacts: true });
            this.props.setContacts([]);
            ChatsService.findContact({
                tenantId: this.props.tenantId,
                search: this.state.search
            }, this.props.setContacts);
        } else {
            this.toastrRef.current.setType("warning");
            this.toastrRef.current.setMessage(this.props.t("leastchars"));
            this.toastrRef.current.show();
        }
    }

    setSearch(e) {
        e.preventDefault();
        this.setState({
            search: e.target.value
        });
    }

    setSearchContacts(value) {
        this.setState({
            searchContacts: value
        });
    }

    searchKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleSearchClick();
        }
    }
    handleStop = (e, data) => {
        let newPos = { x: data.x, y: data.y };

        this.setState({
            position: newPos,
            phoneCursor: "pointer"
        });

        localStorage.setItem("phone-position", JSON.stringify(newPos));
    };

    handleStart = (e, data) => {
        this.setState({
            phoneCursor: "grabbing"
        })
    };

    extraClick(e) {
        e.preventDefault();
        this.props.deselectInteraction();
        this.props.navigate("extra");
        this.setState({
            showForm: false,
            showBook: false
        });
    }

    toggleSessionClosed() {
        this.setState({
            showSessionClosedModal: !this.state.showSessionClosedModal
        });
    }

    toggleReqDevice() {
        this.setState({
            reqDeviceShow: !this.state.reqDeviceShow
        });
    }

    render() {
        const { DynamicComponent } = this.state;
        
        return (
            <div style={{ height: "100%", maxWidth: "100%", position: "relative" }}>
                <div className="d-flex flex-column flex-root">
                    <div className="page d-flex flex-row flex-column-fluid">
                        <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                            <div id="kt_header" className="header">

                                <div className="header-top d-flex align-items-stretch flex-grow-1">

                                    <div className="d-flex align-items-stretch">
                                        <div className="d-flex align-items-center align-items-lg-stretch me-5 flex-row-fluid">
                                            <a className="d-flex align-items-center" onClick={this.logoClick} href="interactions">
                                                <img alt="Logo" src="img/loginlogo.png" className="h-50px" />
                                            </a>
                                            <div className="align-self-end overflow-auto" id="kt_brand_tabs">

                                                <div className="header-tabs overflow-auto mx-4 ms-lg-10 mb-5 mb-lg-0" id="kt_header_tabs" >

                                                    <ul className="nav flex-nowrap text-nowrap">
                                                        <li className="nav-item" >

                                                            <a className={"nav-link " + (window.location.hash.indexOf("interactions") > -1 ? "active" : "")} data-bs-toggle="tab" href="interactions" onClick={this.inboxClick}>{this.props.t("inbox")}
                                                                {
                                                                    (this.props.interactions && this.props.interactions.length > 0) &&
                                                                    <span className={"bullet bullet-dot " + (this.props.unreadMessages > 0 ? "bg-danger" : "bg-success") + " h-6px w-6px position-relative translate-middle top-0 animation-blink"} style={{ left: "10px" }}></span>
                                                                }
                                                            </a>

                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={"nav-link " + (window.location.hash.indexOf("contacts") > -1 ? "active" : "")} data-bs-toggle="tab" href="contacts" onClick={this.contactsClick}>{this.props.t("addressbook")}</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={"nav-link " + (window.location.hash.indexOf("reports") > -1 ? "active" : "")} data-bs-toggle="tab" href="reports" onClick={this.reportsClick}>{this.props.t("history")}</a>
                                                        </li>
                                                        {
                                                            this.props.showDashboard &&
                                                            <li className="nav-item">
                                                                <a className={"nav-link " + (window.location.hash.indexOf("dashboard") > -1 ? "active" : "")} data-bs-toggle="tab" href="dashboard" onClick={this.dashboardClick}>{this.props.t("dashboard")}</a>
                                                            </li>
                                                        }
                                                        {
                                                            //param 462
                                                            this.props.functions?.extraPanel?.length > 0 &&
                                                            <li className="nav-item">
                                                                <a className={"nav-link " + (window.location.hash.indexOf("extra") > -1 ? "active" : "")} data-bs-toggle="tab" href="extra" onClick={this.extraClick}>{this.props?.functions?.extraPanelName}</a>
                                                            </li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <ErrorBoundary>
                                            <AgentStatus hideFormUrl={this.hideFormUrl} form={this.state.form}></AgentStatus>
                                        </ErrorBoundary>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                <ErrorBoundary>
                    <AgentGroups></AgentGroups>
                </ErrorBoundary>

                <ErrorBoundary>
                    <Row className="content" style={{ display: (this.state.showForm !== true && (this.state.showBook !== true || this.state.form !== "" || this.props.phoneStatus.activeCallGUID === null)) ? "flex" : "none" }}>
                        <Col>
                            <Outlet context={{ reconnect: this.login }} />
                        </Col>
                    </Row>
                </ErrorBoundary>

                <ErrorBoundary>
                    <div className="content" style={{ display: (this.state.showForm === true || (this.state.showBook === true && this.props.phoneStatus.activeCallGUID)) ? "block" : "none" }}>

                        <Row style={{ display: "flex" }}>
                            <Col className={
                                "fs-4 pb-3 " +
                                (this.state.view === "form" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                            }
                                style={{ display: this.state.form !== "" ? "inline-block" : "none" }}
                                onClick={this.formClick} >
                                <FontAwesomeIcon icon={duotone('file-invoice')} /> <span className='chattab'>{this.props.t("form")}</span>
                            </Col>
                            {
                                (this.props.functions != null && (this.state.form.indexOf("incoming") !== -1 ||
                                    (this.state.form.indexOf("incoming") === -1 && this.props.functions.searchAddressBookOnOutbound))) &&
                                <Col className={
                                    "fs-4 pb-3 " +
                                    (this.state.view === "contact" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                } onClick={this.contactClick}>
                                    <FontAwesomeIcon icon={duotone('address-book')} /> <span className='chattab'>{this.props.t("contact")}</span>
                                </Col>
                            }
                            <Col className={
                                "fs-4 pb-3 " +
                                (this.state.view === "timeline" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                            } onClick={this.timelineClick}>
                                <FontAwesomeIcon icon={duotone('rectangle-history-circle-user')} /> <span className='chattab'>{this.props.t("timeline")}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{ display: (this.state.view === "form") ? "inline-block" : "none" }}>
                                <ErrorBoundary>
                                    <ContactFormCall form={this.state.form} hideFormUrl={this.hideFormUrl} />
                                </ErrorBoundary>
                            </Col>
                            <Col style={{ display: this.state.view === "contact" ? "inline-block" : "none" }}>
                                <Row style={{ paddingBottom: "20px" }}>
                                    <Col lg={4}>
                                        <Form.Control className='searchinput' style={{ "position": "relative", "top": "8px", left: "-10px" }} type="text" placeholder={this.props.t("search")} value={this.state.search} onChange={this.setSearch} onKeyDown={this.searchKeyDown}></Form.Control>
                                    </Col>
                                    <Col lg={2}>
                                        <Button size='sm' variant="primary" onClick={this.handleSearchClick} className="filterbutton " style={{ "margin": "10px 5px" }}>
                                            <FontAwesomeIcon icon={solid("magnifying-glass")} />
                                        </Button>
                                        <Button size='sm' variant="primary" onClick={this.toggleNewContact} className="filterbutton " style={{ "margin": "10px 5px" }}>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {
                                            ((this.props.contacts.length === 1 && !this.state.searchContacts) || this.state.newContact) &&
                                            <ErrorBoundary>
                                                <AddressBookFormCall key={"call"} contacts={this.props.contacts} mode="call" />
                                            </ErrorBoundary>
                                        }

                                        {
                                            (!this.state.newContact && ((this.state.searchContacts && this.props.contacts.length > 0) ||
                                                (!this.state.searchContacts && this.props.contacts.length > 1))) &&
                                            <ErrorBoundary>
                                                <FidelityContactsSelection key={"call"} contacts={this.props.contacts} setSearchContacts={this.setSearchContacts} mode="call" />
                                            </ErrorBoundary>
                                        }

                                        {
                                            this.props.contacts.length === 0 &&
                                            <div className='d-flex flex-column flex-center' style={{ position: "relative", top: "50%" }}>
                                                <div className="fs-1 text-center">Fidelity</div>
                                                <div className="fs-4 text-muted text-center">{this.props.t("nocontactsfound")}</div>
                                                <div className='nochatsimg'></div>
                                            </div>
                                        }

                                    </Col>
                                </Row>


                            </Col>
                            {this.state.view === "timeline" && (
                                <ErrorBoundary>
                                    <Col>
                                        {this.state.interaction && <Timeline interaction={this.state.interaction} />}
                                    </Col>
                                </ErrorBoundary>
                            )}
                        </Row>

                    </div>
                </ErrorBoundary>


                {
                    //!MIGHT REMOVE THE DRAGGABLE
                }
                <ErrorBoundary>
                    <Draggable
                        handle=".drag"
                        position={this.state.position}
                        bounds="parent"
                        onStart={this.handleStart}
                        onStop={this.handleStop}
                    >
                        <div className="drag" style={{ position: "absolute", zIndex: 3, cursor: this.state.phoneCursor }}><Phone toggleForm={this.toggleForm} toggleBook={this.toggleBook} form={this.state.form}></Phone></div>
                    </ Draggable>
                </ErrorBoundary>

                <ErrorBoundary>
                    <AiAssistant></AiAssistant>
                </ErrorBoundary>
                
                <ErrorBoundary>
                    <ChatEventDispacherService />
                </ErrorBoundary>

                {
                    this.props.integrationScript && DynamicComponent &&
                    <ErrorBoundary>
                        <DynamicComponent phoneStatus={this.props.phoneStatus} toggleReqDevice={this.toggleReqDevice} toastr={this.toastrRef} t={this.props.t} />
                    </ErrorBoundary>
                }

                <ErrorBoundary>
                    <RequestDevice show={this.state.reqDeviceShow} toggleModal={this.toggleReqDevice} />
                </ErrorBoundary>
                
                <Toastr ref={this.toastrRef} />
                <MonitorSessionClosedNotification show={this.state.showSessionClosedModal} hideModal={this.toggleSessionClosed} reconnect={this.login}></MonitorSessionClosedNotification>


            </div>
        );
    };
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <Main {...props} navigate={navigate} />
}

const mapStateToProps = (state) => {
    return {
        interactions: state.interaction.interactions,
        unreadMessages: state.interaction.unreadMessages,
        showDashboard: state.parameters.showDashboard,
        contacts: state.agent.contacts,
        functions: state.agent.functions,
        phoneStatus: state.agent.phoneStatus,
        chatUrl: state.parameters.chatUrl,
        tenantId: state.agent.tenantId,
        aiEnabled: state.parameters.aiEnabled,
        extraCallData: state.agent.extraCallData,
        extraCallDataType: state.agent.extraCallDataType,
        token: state.agent.monitorToken,
        userId: state.agent.userId,
        connected: state.agent.monitorConnected,
        integrationScript: state.parameters.integrationScript
    };
};

export default compose(connect(mapStateToProps, { deselectInteraction, clearContacts, setAiEnabled, setContacts, setMonitorToken, setMonitorConnected, setMonitorConnectionLost }), withTranslation())(WithNavigate);